var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduledTripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_401_29327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 3H6.82734C5.14719 3 4.30711 3 3.66537 3.32698C3.10089 3.6146 2.64194 4.07354 2.35432 4.63803C2.02734 5.27976 2.02734 6.11984 2.02734 7.8V10.5M8.02734 3H17.0273M8.02734 3V1.5M8.02734 3V6M17.0273 3H18.2273C19.9075 3 20.7476 3 21.3893 3.32698C21.9538 3.6146 22.4127 4.07354 22.7004 4.63803C23.0273 5.27976 23.0273 6.11984 23.0273 7.8V10.5M17.0273 3V1.5M17.0273 3V6M23.0273 10.5V17.7C23.0273 19.3802 23.0273 20.2202 22.7004 20.862C22.4127 21.4265 21.9538 21.8854 21.3893 22.173C20.7476 22.5 19.9075 22.5 18.2273 22.5H6.82734C5.14719 22.5 4.30711 22.5 3.66537 22.173C3.10089 21.8854 2.64194 21.4265 2.35432 20.862C2.02734 20.2202 2.02734 19.3802 2.02734 17.7V10.5M23.0273 10.5H2.02734",
    stroke: "#535353",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_29327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.527344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledTripIcon);
export default __webpack_public_path__ + "static/media/scheduledTripIcon.d879547b6e694ef84000d907962d791c.svg";
export { ForwardRef as ReactComponent };